import Common from './common';
const common = new Common();

export default class Header {
  init() {
    this.header();
    this.megamenu();
  }
  header(){
    var { media } = common.getEnvironment();
    if(media == 'sp'){
      let isOpen = false;
      $('.headerToggle').click(function(){
        isOpen = !isOpen;
        $('.l_header_search_wrap').slideToggle();
        if (isOpen) {
          $('.l_header_search_input').focus();
        }
        $('.l_header_nav_wrap').hide();
        $('.js_header_btn').removeClass('is_open');
      });
      $('.l_header_close_icon').click(function() {
        $('.l_header_search_wrap').slideUp();
      });

      $('.js_header_btn').click(function() {
        $('.l_header_search_wrap').hide();
        $('.l_header_nav_wrap').slideToggle();
        $(this).toggleClass('is_open');
      });
    }else{
      $('.headerToggle').click(function(){
        $('.l_header_search_wrap').slideToggle(function () {
          $('.l_header_search_input').focus();
        });
      });
      $('.l_header_close_icon').click(function() {
        $('.l_header_search_wrap').slideUp();
      });

      $(window).on('keydown', function (e) {
        if (e.keyCode == 27) {
          $('.l_header_search_wrap').slideUp();
          return false;
        }
      });
    }
  }

  megamenu(){
    var { media } = common.getEnvironment();
    if(media == 'pc'){
      $('.l_header_nav_item_arrow').hover(function() {
        var menuBtn = $(this).data('menu-btn');
        $('.l_header_mega_menu_wrap').each(function() {
          var menu = $(this).data('menu');
          if(menuBtn === menu){
            $(this).addClass('is_open');
          }else{
            $(this).removeClass('is_open');
          }
        });
      });
      $('.l_header_nav_wrap').mouseleave(function() {
        $('.l_header_mega_menu_wrap').removeClass('is_open');
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/modules/header.js